<div class="np-better-route" data-testid="nav-plan-better-route-container">
  <div class="np-better-route-hero">
    <div class="np-better-route-hero-icon">
      <!-- Class, not id: the recolor directive keeps the asset's own id. -->
      <img class="np-better-route-icon" alt="better route icon"
        [appSvgRecolor]="'assets/icons/dark/ui/stopwatch_icon.svg'"
        [recolorColor]="'#fff'" />
    </div>
    <div class="np-better-route-hero-text">
      <span class="np-better-route-hero-eyebrow">{{ languageService.languageJSON.NavigationHud_ReplanTitle }}</span>
      <span class="np-better-route-hero-message">{{ message }}</span>
    </div>

    <!-- Drains over exactly the auto-dismiss timeout, so the strip shows how
         long the offer stays on screen. -->
    <div class="np-better-route-countdown" aria-hidden="true">
      <div class="np-better-route-countdown-fill" [style.animationDuration.ms]="timeoutMs"></div>
    </div>
  </div>

  <div class="np-actions" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" data-testid="nav-plan-better-route-actions-container">
    <button class="ev-button primary" (click)="onAccept()" data-testid="nav-plan-better-route-replan-btn">
      {{ languageService.languageJSON.Global_Replan }}
    </button>
    <button class="ev-button" (click)="onDismiss()" data-testid="nav-plan-better-route-dismiss-btn">
      {{ languageService.languageJSON.Global_Cancel }}
    </button>
  </div>
</div>
